export enum hoverBtns {
    Default,
    Delete,
    Edit,
    Save
}
